
export function mapValidationFieldsToClassName(state, field, defaultClassName) {
    const className = state.getIn(['validationErrors', 'fields'], []).includes(field)
        ? `validation-error ${defaultClassName}`
        : `${defaultClassName}`

    return {className: className}
}



/** WEBPACK FOOTER **
 ** ./src/components/search/forms/inputValidations.js
 **/